// Module
var code = "<div class=\"Library\"> <div id=\"main-content-view\" ui-view=\"childcontent\" class=\"reset-ui-view\"></div> </div> ";
// Exports
export default code;